<script lang="ts">
  const APP_NAME = process.env.APP_NAME;
</script>

<nav
  class="custom-navbar z-10 relative bg-white shadow-md flex items-center px-6"
>
  <div class="font-bold text-lg">
    {APP_NAME}
  </div>
</nav>

<style scoped>
  .custom-navbar {
    height: var(--custom-navbar-height);
  }
</style>
